import './main.css';

import Header from "./components/Header/Header";
import Instruction from './components/Instruction/Instruction';
import Test from './components/Test/Test';
import Results from './components/Results/Results';
import Footer from './components/Footer/Footer';

import ScrollToTop from './components/ScrollToTop';

import { BrowserRouter } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom';

function App() {
  return (
    <BrowserRouter>
    <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route path='/' element={<Instruction />}/>
          <Route path='/test' element={<Test />} />
          <Route path='/results' element={<Results />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
